module.exports = __webpack_public_path__ + "static/media/smart_subscription.f232c8d6.png";